let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7S12o")).then(() => parcelRequire('1Z5O1'));